import axios from 'axios';

const BASE_URL = 'https://agentes.therealdevs.pro/index.php/';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  // Timeout de 10 segundos para que no se quede colgado
  timeout: 10000
});

// Interceptor para inyectar el Token automáticamente en cada petición
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('neurals_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores globales (ej: token vencido)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Si el backend dice "No autorizado", sacamos al usuario
      console.warn('Sesión expirada o inválida');
      localStorage.removeItem('neurals_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;